
<span v-show="visible" class="vnode__drag-handle">
  <el-tooltip content="Click &amp; Drag">
    <i class="material-icons">drag_handle</i>
  </el-tooltip>
</span>
